import queryString from "query-string";
import { useHistory } from "react-router-dom";
import { useFindingEntity } from "../Findings/findingEntity";

type QueryStringObjectProps = Partial<{
  filterId: string;
  scopeId: string;
  filterToExecute: string;
  scopeToExecute: string;
}>;

const useAppViewNavigator = () => {
  const history = useHistory();
  const { buildRemediationItemHref } = useFindingEntity();
  const defaultUrl = buildRemediationItemHref();

  const appViewNavigator = (
    filterId: string | null = null,
    scopeId: string | null = null,
    filterToExecute: string | null = null,
    scopeToExecute: string | null = null,
    openInNewTab: boolean = false,
    url: string = defaultUrl,
    updateFilterOnlyIfDefaultUrl: boolean = true
  ) => {
    const queryStringObj: QueryStringObjectProps = {};
    const shouldUpdateFilter =
      !updateFilterOnlyIfDefaultUrl || url === defaultUrl;
    if (!!filterId && shouldUpdateFilter) {
      queryStringObj.filterId = filterId;
    }
    if (!!scopeId) {
      queryStringObj.scopeId = scopeId;
    }
    if (!!filterToExecute && shouldUpdateFilter) {
      queryStringObj.filterToExecute = filterToExecute;
    }

    if (!!scopeToExecute) {
      queryStringObj.scopeToExecute = scopeToExecute;
    }

    const queryStringURL = queryString.stringifyUrl({
      url: url,
      query: queryStringObj,
    });

    if (openInNewTab) {
      window.open(queryStringURL);
    } else {
      history.push(queryStringURL);
    }
  };

  return {
    appViewNavigator,
  };
};

export default useAppViewNavigator;
